import { injectKendoLegacyStyles } from "../lib/kendo-style-injector";
import "../widgets/customdatetimepicker";

export interface instoreform {
  openButton: string;
  errorLabel: string;
  storeIdField: string;
  nameField: string;
  phoneField: string;
  timeField: string;
  btnSubmit: string;
  window: string;
}

function setupTimePicker(timeFieldId: string) {
  const $timePicker = $("#" + timeFieldId),
    coeff = 1000 * 60 * 15,
    date = new Date(),
    rounded = new Date(Math.ceil(date.getTime() / coeff) * coeff);

  $timePicker.kendoCustomDateTimePicker({
    value: rounded,
    min: rounded,
    interval: 15,
    change: function () {
      this.startTime("08:00");
      this.endTime("18:00");
    },
  });

  const datepicker = $timePicker.data("kendoCustomDateTimePicker");
  if (datepicker) {
    datepicker.startTime("08:00");
    datepicker.endTime("18:00");
  }
}

export function setupStorePickupForm(inStoreFormIds: instoreform) {
  const $inStoreWindow = $("#" + inStoreFormIds.window);

  $inStoreWindow.find(".close-button").click(() => {
    $inStoreWindow.slideUp();
  });

  if ($("#" + inStoreFormIds.errorLabel).length) {
    $inStoreWindow.show();
  }

  setupTimePicker(inStoreFormIds.timeField);

  const openButton = document.getElementById(inStoreFormIds.openButton) as
    | HTMLElement
    | undefined;

  if (openButton) {
    openButton.addEventListener("click", () => {
      injectKendoLegacyStyles();
      $inStoreWindow.slideDown();
    });
  }
}
